import Request from './request'

const Rpc = {
  getRPCIndex (params, callback) {
    Request.get('rpc/index', params).then(callback).catch(this.bad_answer)
  },
}
export default Rpc
